"use client"
import React, { useState, useEffect } from "react";
import Select from "react-select";
import { Form } from "react-bootstrap";

import "@/components/maps/MapLayerSelector.css";
import useUtils from "@/components/shared/useUtils";

const MapLayerSelector = ({
  layers,
  selected,
  onSelect,
  isClearable,
  allowAll,
  label
}) => {
  const utils = useUtils();

  const targetHeight = 54;

  const customStyles = {
    menuPortal: base => ({
      ...base,
      zIndex: 9999
    }),
    control: base => ({
      ...base,
      minHeight: "initial"
    }),
    valueContainer: base => ({
      ...base,
      height: `${targetHeight - 1 - 1}px`,
      padding: "0 8px"
    }),
    clearIndicator: base => ({
      ...base,
      padding: `${(targetHeight - 20 - 1 - 1) / 2}px`
    }),
    dropdownIndicator: base => ({
      ...base,
      padding: `${(targetHeight - 20 - 1 - 1) / 2}px`
    })
  };

  const [options, setOptions] = useState([]);

  useEffect(() => {
    if (layers) {
      var newOptions = [];
      if (allowAll) {
        newOptions.push({ value: null, label: "All Layers" });
      }
      layers.forEach(function(layer, index) {
        newOptions.push(layer);
      });
      setOptions(newOptions);
    }
  }, [layers]);

  const theIcon = (layerMarkerType, layerMarkerRef, icon, shape = "PIN") => {
    return (
      <img
        className="layer-marker"
        src={utils.markerUrl(layerMarkerRef, icon, shape)}
      />
    );
  };

  const formatOptionLabel = ({
    value,
    label,
    layerMarkerRef,
    layerMarkerType,
    icon,
    shape
  }) => (
    <div className="layer-option-label">
      {value && <>{theIcon(layerMarkerType, layerMarkerRef, icon, shape)}</>}
      {label}
    </div>
  );

  return (
    <div style={{ position: "relative", zIndex: 400 }}>
      <div className="form-group" id="categoryDropdownSelect">
        {label && <Form.Label>{label}</Form.Label>}
        <Select
          className="select basic-single"
          classNamePrefix="select"
          menuPortalTarget={document.body}
          isClearable={isClearable}
          isSearchable={false}
          styles={customStyles}
          name="layer"
          options={options}
          value={selected ? options.find(o => o.value === selected) : null}
          onChange={option =>
            option ? onSelect(option.value) : onSelect(null)
          }
          formatOptionLabel={formatOptionLabel}
        />
      </div>
    </div>
  );
};
export default MapLayerSelector;
